export default "__VITE_ASSET__DJwIBRON__"